export default [
  {
    label: 'Analytics',
    value: 'analytics',
  },
  {
    label: 'Dashboards',
    value: 'dashboards',
  },
  {
    label: 'Products',
    value: 'products',
  },
];
